module.exports = __webpack_public_path__ + "img/single_pictures_6.73734774.jpg";